import React from 'react'
import ManageNotification from './ManageNotification'

// SELECT 'notiType' AS Type, CAST(ME.[Value] AS nvarchar) AS Value, CAST(ME.Label AS nvarchar) AS Label
// FROM MasterEnums AS ME
// WHERE Name = 'notiType'
// ORDER BY ME.NumberOfSequence
const NOTIFICATION_TYPE = {
  ELSE: {
    TYPE: 0,
    TITLE: 'จัดการแจ้งเตือน',
    NOTE: 'อื่นๆ',
  },
  ASSET: {
    TYPE: 1,
    TITLE: 'จัดการแจ้งเตือนครุภัณฑ์',
    NOTE: 'ตรวจนับครุภัณฑ์',
  },
}

//#region  อื่นๆ
export function ManageNotificationElse() {
  return (
    <ManageNotification
      useType={NOTIFICATION_TYPE.ELSE.TYPE}
      title={NOTIFICATION_TYPE.ELSE.TITLE}
      _isIncomeExpenseApprover={false}
      _isManagement={true}
    />
  )
}
//#endregion อื่นๆ

//#region  ตรวจนับครุภัณฑ์
export function ManageNotificationAsset() {
  return (
    <ManageNotification
      useType={NOTIFICATION_TYPE.ASSET.TYPE}
      title={NOTIFICATION_TYPE.ASSET.TITLE}
      _isIncomeExpenseApprover={true}
      _isManagement={false}
    />
  )
}
//#endregion ตรวจนับครุภัณฑ์
